import { ArrayElement, TypeOrArray } from "@hex-insights/core";
import { ExportButton as BaseExportButton, ExportButtonProps as BaseExportButtonProps } from "../../../Components";
import {
	CalendarEventFilterInput,
	CalendarEventIndexDocument,
	CalendarEventIndexQuery,
	CalendarEventOrderField,
	CalendarEventPaginationDocument,
} from "../../../Utilities";
import { CalendarEventFormat } from "../../Format";

const columnNames = [
	"id",
	"name",
	"description",
	"location",
	"status",
	"isAllDay",
	"startTime",
	"endTime",
	"startDate",
	"isMultiDay",
	"endDate",
	"allowsResponses",
] as const;

type Column = ArrayElement<typeof columnNames>;

type Node = CalendarEventIndexQuery["calendarEventConnection"]["edges"][0]["node"];

type ExportButtonProps = Omit<
	BaseExportButtonProps<Node, TypeOrArray<CalendarEventFilterInput>, CalendarEventOrderField | null, Column>,
	"dataQuery" | "paginationQuery" | "fileNamePrefix" | "resultKey" | "columns" | "formatRow"
> & {
	columns?: Record<string, boolean>;
};

export function ExportButton({ queryVariables, resultsPerPage, columns }: ExportButtonProps) {
	const activeColumnNames = columnNames.filter((e) => e === "id" || (columns?.[e] ?? true));

	return (
		<BaseExportButton<Node, TypeOrArray<CalendarEventFilterInput>, CalendarEventOrderField | null, Column>
			queryVariables={queryVariables}
			dataQuery={CalendarEventIndexDocument}
			paginationQuery={CalendarEventPaginationDocument}
			resultsPerPage={resultsPerPage}
			fileNamePrefix="calendarEvents"
			resultKey="calendarEventConnection"
			columns={activeColumnNames}
			formatRow={formatRow}
		/>
	);
}

function formatRow(node: Node): Record<Column, any> {
	return {
		id: node.id,
		name: CalendarEventFormat.Fields.name(node.name),
		description: CalendarEventFormat.Fields.description(node.description),
		location: CalendarEventFormat.Fields.location(node.location),
		status: CalendarEventFormat.status(node),
		isAllDay: CalendarEventFormat.Fields.isAllDay(node.isAllDay),
		startTime: CalendarEventFormat.Fields.startTime(node.startTime),
		endTime: CalendarEventFormat.Fields.endTime(node.endTime),
		startDate: CalendarEventFormat.Fields.startDate(node.startDate),
		isMultiDay: CalendarEventFormat.Fields.isMultiDay(node.isMultiDay),
		endDate: CalendarEventFormat.Fields.endDate(node.endDate),
		allowsResponses: CalendarEventFormat.Fields.allowsResponses(node.allowsResponses),
	};
}
